import { Box, VStack, Text, FormControl, Input, Button, Modal } from 'native-base'
import React from 'react'
import validate from 'validate.js'

function EditCredit(props) {
    const { t, member, chain, isSuccessModalVisible } = props
    const [validationErrors, setValidationErrors] = React.useState({})
    const [formData, setData] = React.useState({});

    const handleOnSubmitPress = () => {
        let _validationErrors = {}
        const billPriceContraint = {
            billPrice: {
                numericality: {
                    greaterThan: 0,
                }
            }
        }
        const billPriceValidate = validate({ billPrice: formData['billPrice'] }, billPriceContraint)
        if (billPriceValidate) {
            _validationErrors['billPrice'] = t('creditErrorMessage')
        }
        if (!billPriceValidate) {
            props.onSubmitPress(formData)
        }
        setValidationErrors(_validationErrors)
    }


    const billPrice = formData.billPrice
    const creditAfter = billPrice ? parseInt(billPrice / chain.rate) + member.credit : member.credit
    return (
        <Box
            flex={1}
            p={2}
            bg={'#ffffff'}
        >
            <VStack space={2} p={6} mt={6} >
                <FormControl my={2} isRequired>
                    <FormControl.Label _text={{ color: 'muted.700', fontSize: 'sm', fontWeight: 400 }}>
                        {t('billPrice')}
                    </FormControl.Label>
                    <Input
                        onChangeText={(value) => setData({ ...formData, billPrice: value })}
                    />
                    {'billPrice' in validationErrors ?
                        <Text color='red.700' fontSize={'xs'}>{validationErrors.billPrice}</Text>
                        : null
                    }
                </FormControl>
                <FormControl my={2}>
                    <FormControl.Label _text={{ color: 'muted.700', fontSize: 'sm', fontWeight: 400 }}>
                        {t('remark')}
                    </FormControl.Label>
                    <Input
                        onChangeText={(value) => setData({ ...formData, remark: value })}
                    />
                </FormControl>
                <Text py={1}>{`${t('creditNow')}: ${member.credit}`}</Text>
                <Text py={1}>{`${t('creditAfter')}: ${creditAfter}`}</Text>
                <VStack space={2} my={2}>
                    <Button _text={{ color: 'white' }} onPress={() => handleOnSubmitPress()}>
                        {t('confirm')}
                    </Button>
                </VStack>
            </VStack>
            <Modal isOpen={isSuccessModalVisible} onClose={() => props.onSuccessModalClose()}>
                <Modal.Content maxWidth="400px">
                    <Modal.CloseButton />
                    <Modal.Header>{t('success')}</Modal.Header>
                    <Modal.Body>
                        {t('topUpSuccess')}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant={'ghost'}
                            onPress={() => {
                                props.onSuccessModalClose()
                            }}
                        >
                            {t('confirm')}
                        </Button>
                    </Modal.Footer>
                </Modal.Content>
            </Modal>
        </Box>
    )
}

export default EditCredit